import { createAction, props } from '@ngrx/store';
import { GeoKLocationLight } from '@app/shared/models/geo-k-location';

export const setSelectedBrand = createAction(
  'set selected brand',
  props<{ brandId: string }>()
);

export const setSelectedLocations = createAction(
  'set selected location ids',
  props<{ locationIds: string[] }>()
);
export const setSelectedLocationsObject = createAction(
  'set selected location',
  props<{ locations: GeoKLocationLight[] }>()
);

export interface LocationListFilters {
  search: string | null;
  brandIds: string[];
  tagIds: string[];
  ratingStart: number;
  ratingEnd: number;
  scoreStart: number;
  scoreEnd: number;
  activity: string | null;
  businessStatus: string;
}

export const setLocationListFilters = createAction(
  'set location list filters',
  props<{ filters: LocationListFilters }>()
);

export const resetLocationListFilters = createAction(
  'reset location list filters'
);
